module.exports = __webpack_public_path__ + "img/PT6100.5f18b63d.png";